<template>
  <v-layout row wrap class="colored-background">
    <v-flex xs12 sm12 md12 class="mt-5 text-xs-center">
      <img width="52%" :src="assetRoot + 'musicplus.png'" />
    </v-flex>
    <v-flex xs12 sm12 md12 class="mx-5 mt-5 text-xs-center">
      <span class="page-title">Enter your email to request a password reset</span>
    </v-flex>
    <v-flex xs12 sm12 md12 class="text-xs-center my-5">
      <v-card class="mx-4 rounded-card">
        <v-container>
          <v-layout column>
            <v-text-field class="input-field" type="email" :disabled="isRequestingResetPassword || accountResetRequested"  background-color="grey lighten-2" single-line outline hide-details v-model="i_email">
              <template v-slot:label>
                <span class="input-label">Email address here</span>
              </template>
            </v-text-field>
            <v-flex class="mt-3">
              <v-btn v-if="accountResetRequested" flat disabled block class="rounded-button-done" color="#4caf50">
                <template v-slot:default>
                  <span class="reset-button">EMAIL SENT!</span>
                </template>
              </v-btn>
              <v-btn v-else block class="rounded-button" color="#2c7fff"
                :disabled="cantRequestResetPassword || isRequestingResetPassword"
                :loading="isRequestingResetPassword"
                @click.stop="requestResetPassword"
              >
                <template v-slot:default>
                  <span v-if="cantRequestResetPassword" class="reset-button-disabled">REQUEST</span>
                  <span v-else class="reset-button">REQUEST</span>
                </template>
              </v-btn>
            </v-flex>
            <v-flex class="mt-3" v-if="requestPasswordStatus === 'error'">
              <span class="error-message">{{ requestPasswordErrorMessage }}</span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        i_email: ''
      }
    },
    methods: {
      requestResetPassword () {
        let payload = {
          env: this.env,
          body: {
            app_key: this.appKey,
            email: this.i_email
          }
        }
        this.$store.dispatch('REQUEST_RESET_PASSWORD', payload)
      }
    },
    computed: {
      ...mapGetters([
        'env',
        'assetRoot',
        'appKey',
        'requestPasswordStatus',
        'requestPasswordErrorMessage',
      ]),
      cantRequestResetPassword () {
        return this.i_email === ''
      },
      isRequestingResetPassword () {
        return this.requestPasswordStatus === 'progress'
      },
      accountResetRequested () {
        return this.requestPasswordStatus === 'done'
      }
    },
    mounted () {
      this.$nextTick(function () {

      })
    }
  }
</script>

<style scoped>
.colored-background {
  background-size: contain;
  background-image:url('https://storage.googleapis.com/mwm-appstore-assets/website_mwm/global_offer/BG-opti.jpg');
  background-color: #05151F;
}

.page-title {
  font-family: CenturyGothic;
  font-size: 1.5rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.rounded-card{
  border-radius:11px;
}

.input-label {
  font-family: CenturyGothic;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #abadad;
}

.input-field {
  font-family: CenturyGothic;
  font-size: 18px;
  background-color: #f8f8f8;
}

.rounded-button {
  border-radius: 11px;
  height: 48px;
  background-color: #2c7fff;
}

.rounded-button-done {
  border-radius: 11px;
  height: 72px;
  background-color: #4caf50;
}

.reset-button {
  font-family: CenturyGothic;
  font-size: 23px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.87;
  letter-spacing: 1.28px;
  color: #ffffff;
}

.reset-button-disabled {
  font-family: CenturyGothic;
  font-size: 23px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.87;
  letter-spacing: 1.28px;
  color: grey;
}

.error-message {
  font-family: CenturyGothic;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: red;
}
</style>
